import { removeHTMLTags } from '@jusbrasil-web/docview/core'
import { organization, siteNavigation, website } from '@jusbrasil-web/shared-utils-seo'

import { ModelMetaTags_DocumentFragment } from './__generated__/model-meta-tags.graphql'

export class ModelSeoMetadata {
  private readonly document

  constructor(document: ModelMetaTags_DocumentFragment) {
    this.document = document
  }

  private getDescription() {
    const { title } = this.document

    return `Confira: ${removeHTMLTags(
      title || ''
    )} para copiar e baixar. Veja mais Modelos e Petições Jurídicas no Jusbrasil.`
  }

  private getStructuredDataItems() {
    const { meta } = this.document

    return {
      article: {
        ...meta,
        alternativeHeadline: meta?.headline ? `${meta?.headline} em Modelos` : null,
        alternateName: meta?.headline || null,
      },
    }
  }

  private buildSeoMetadata() {
    const { title, noIndex } = this.document

    const description = this.getDescription()
    const { article } = this.getStructuredDataItems()

    return {
      title: `${title || ''} | Jusbrasil`,
      description,
      keywords: [],
      structuredData: {
        '@context': 'https://schema.org',
        '@graph': [organization, website, siteNavigation, article].filter(Boolean),
      },
      noIndex,
    }
  }

  getSeoMetadata() {
    return this.buildSeoMetadata()
  }
}
